import { PodcastListType } from '@nimey/podcast-global-entity';
import { ListLayout, PodcastList } from './podcast';


export const AnonymousPodcasts = (props: { limit?: number }) => {
  return <PodcastList layout={ListLayout.TILES} listType={PodcastListType.ALL} {...props} title='Folgende Podcast könnten dich interessieren' />
}